import { render, staticRenderFns } from "./RevStatus.vue?vue&type=template&id=a621f808"
import script from "./RevStatus.vue?vue&type=script&lang=js"
export * from "./RevStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports